import React, { createContext, useContext, useState, useEffect } from 'react';
import { checkAuth } from '../utils/apiHelper';

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [license, setLicense] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  const fetchUserData = async () => {
    try {
      const authResult = await checkAuth();
      if (authResult.authenticated) {
        setUser(authResult.user);
        setLicense(authResult.license);
        setAuthenticated(true);
      } else {
        setUser(null);
        setLicense(null);
        setAuthenticated(false);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
      setUser(null);
      setLicense(null);
      setAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const refreshUserData = () => {
    return fetchUserData();
  };

  return (
    <UserContext.Provider value={{ user, license, loading, authenticated, refreshUserData }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
